import Loading from '@/components/general/Loading';
import useApiFetch from '@/hooks/useApiFetch';
import trendsApi from '@/services/trends';
import { FetchApiIds } from '@/types';
import { ResponseGetTrends } from '@/types/api';
import TrendsReportListPage from './TrendsReportList.component';

const TrendsReportListContainer = function (): JSX.Element {
  const getTrendsResponse = useApiFetch<ResponseGetTrends>([FetchApiIds.TRENDS], async () =>
    trendsApi.getTrends()
  );

  if (getTrendsResponse.isLoading) return <Loading fullPage />;

  return <TrendsReportListPage trends={getTrendsResponse.data?.trends || []} />;
};

export default TrendsReportListContainer;
